export const API_URL = import.meta.env.VITE_API_URL;
export const SITE_URL = import.meta.env.VITE_SITE_URL;
export const YANDEX_METRIKA_ID = import.meta.env.VITE_YANDEX_METRIKA_ID
export const SID = import.meta.env.VITE_SID

